<template>
  <div class="instrument_index">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- 科室 -->
      <el-tab-pane :label="`科室`" name="first">
        <div class="search-line">
          <!-- 科室 -->
            <div class="left">
              <el-autocomplete
              class="search-input"
              v-model="queryParams.name"
              :fetch-suggestions="getDep"
              value-key="name"
              clearable
              :placeholder="`科室`"
            ></el-autocomplete>
              <!-- 处理中心 -->
              <el-select class="ml10" v-model="queryParams.center_id" clearable filterable :placeholder="`处理中心`" v-if="user.type == 1">
                <el-option
                  v-for="item in deptCenter"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <!-- 类别 -->
              <el-select v-model="queryParams.type" clearable filterable class="input300 ml10" :placeholder="`类别`">
                <el-option
                        v-for="item in typeOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.value"
                ></el-option>
              </el-select>
              <!-- 查询 -->
              <el-button class="ml10" type="primary" icon="el-icon-search" size="mini" @click="getSearch">查询</el-button>
              <!-- 新建 -->
              <el-button type="primary" icon="el-icon-plus" size="mini" @click="createDepartment">新建</el-button>
              <!-- 导入 -->
              <el-button type="primary" icon="el-icon-upload2" size="mini" @click="importList()" v-if="user.type == 1">导入</el-button>
              <!-- 添加处理中心 -->
              <el-button type="primary" icon="el-icon-plus" size="mini" @click="createProcesscenter" v-if="user.type == 1">添加处理中心</el-button>
              <!-- 添加院区 -->
              <el-button type="primary" icon="el-icon-plus" size="mini" @click="createSite" v-if="user.type == 1">添加院区</el-button>
              <!-- 同步数据 -->
              <el-button type="primary" icon="el-icon-refresh" size="mini" @click="pullData" v-if="exec[89]">同步数据</el-button>
            </div>
            <table-header-editor :headers="tableHeaders" class="header-editor" />
        </div>
        <div class="instrument_center mt10">
          <div class="list-content">
            <el-table
              :data="departmentList"
              stripe 
              v-loading="loading"
              :header-cell-class-name="'table-header-cell'"
              @sort-change="sortChange"
              border
            >
              <el-table-column
                v-for="(item) in tableHeaders"
                :key="item.id"
                :type="item.type"
                :label="item.label"
                :prop="item.prop"
                :sortable="!!item.sortKey ? 'custom': false"
                :sort-by="item.sortKey"
                :width="item.width">
                  <template slot-scope="scope">
                    <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
                    <img v-else-if="item.prop === 'code'" :src="`${$utils.generateCode(scope.row.code)}`" alt="" class="qr-code">
                    <span v-else-if="item.handle && scope.row.type != 1">
                      <!-- 编辑 -->
                      <el-tooltip effect="dark" :content="`编辑`" placement="top-start">
                        <el-button class="p0 fontsize20" type="text" @click="editDepartment(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
                      </el-tooltip>
                      <!-- 删除 -->
                      <el-tooltip effect="dark" :content="`删除`" placement="top-start">
                        <el-button class="p0 fontsize20" type="text" @click.prevent="deleteDepartment(scope.row.id)"><i class="el-icon-delete"></i></el-button>
                      </el-tooltip>
                    </span>
                    <span v-else>{{scope.row[item.prop]}}</span>
                  </template>
              </el-table-column>
            </el-table>
          </div>
          <pagination :queryParams="queryParams" :getList="getdepartmentList" />
        </div>
      </el-tab-pane>
      <!-- 科室组 -->
      <el-tab-pane :label="`科室组`" name="second">
        <div class="search-line">
            <div class="left">
              <!-- 科室组 -->
              <el-input v-model="queryGruopParams.name" class="search-input" clearable :placeholder="`科室组`"></el-input>
              <!-- 查询 -->
              <el-button type="primary" icon="el-icon-search" size="mini" @click="getSearchGroup">查询</el-button>
              <!-- 新建科室组 -->
              <el-button type="primary" icon="el-icon-plus" size="mini" @click.prevent="createGruop">新建科室组</el-button>
            </div>
            <table-header-editor :headers="tableHeadersTwo" class="header-editor" />
        </div>
        <div class="instrument_center mt10">
          <div class="list-content">
            <el-table
              :data="departmentGroupList"
              stripe 
              v-loading="loading"
              :header-cell-class-name="'table-header-cell'"
              border
              @sort-change="sortGroupChange"
            >
              <el-table-column
                v-for="(item, index) in tableHeadersTwo"
                :key="index"
                :type="item.type"
                :label="item.label"
                :prop="item.prop"
                :sortable="!!item.sortKey ? 'custom': false"
                :sort-by="item.sortKey"
                :width="item.width">
                  <template slot-scope="scope">
                    <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
                    <span v-else>{{scope.row[item.prop]}}</span>
                    <!-- 编辑 -->
                    <el-tooltip v-if="item.handle" effect="dark" :content="`编辑`" placement="top-start">
                      <el-button class="p0 fontsize20" type="text" @click.prevent="departmentGroupEdit(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
                    </el-tooltip>
                    <!-- 删除 -->
                    <el-tooltip v-if="item.handle" effect="dark" :content="`删除`" placement="top-start">
                      <el-button class="p0 fontsize20" type="text" @click.prevent="deletedeptGroup(scope.row.id)"><i class="el-icon-delete"></i></el-button>
                    </el-tooltip>
                  </template>
              </el-table-column>
            </el-table>
          </div>
          <pagination :queryParams="queryGruopParams" :getList="getDepartmentGroupList" />
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 新建、编辑科室对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="1200px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :inline="true" :model="form" :rules="rules" label-width="260px">
        <!-- 科室 -->
        <el-form-item :label="`科室`" prop="name">
          <el-input v-model="form.name" class="input250" :placeholder="`请输入`" />
        </el-form-item>
        <!-- 类别 -->
        <el-form-item :label="`类别`" prop="type">
          <el-select v-model="form.type" clearable filterable class="input250" :placeholder="`请选择`">
            <el-option
              v-for="item in typeOptions"
              :key="item.id"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 父级科室 -->
        <el-form-item :label="`父级科室`">
          <el-select v-model="form.parent_id" clearable filterable class="input250" :placeholder="`请选择`">
            <el-option
              v-for="item in departmentOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              :disabled="form.id == item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 科室组 -->
        <el-form-item :label="`科室组`" prop="department_group">
          <el-select v-model="form.department_group_id" clearable filterable multiple class="input250" :placeholder="`请选择`">
            <el-option
              v-for="item in deptGroupOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- 保 存 -->
        <el-button size="mini" :loading="buttonLoading" type="primary" @click="submitForm">保存</el-button>
        <!-- 取 消 -->
        <el-button size="mini" @click="closedept">取消</el-button>
      </div>
    </el-dialog>

    <!-- 编辑科室组对话框 -->
    <el-dialog :title="title" :visible.sync="openGroup" width="500px" append-to-body :close-on-click-modal="false">
      <el-form ref="formGroup" :model="formGroup" :rules="rulesGroup" label-width="160px">
        <!-- 科室组 -->
        <el-form-item :label="`科室组`" prop="name">
          <el-input v-model="formGroup.name" class="input250" :placeholder="`请输入`" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- 保 存 -->
        <el-button size="mini" :loading="buttonLoading" type="primary" @click="departmentGropCreate">保存</el-button>
        <!-- 取 消 -->
        <el-button size="mini" @click="closeGroup">取消</el-button>
      </div>
    </el-dialog>
    
    <!-- 新建处理中心对话框 -->
    <el-dialog :title="title" :visible.sync="openCenter" width="500px" append-to-body>
      <el-form ref="formCenter" :model="formCenter" :rules="rulesCenter" label-width="110px">
        <!-- 处理中心 -->
        <el-form-item :label="`处理中心`" prop="name">
          <el-input v-model="formCenter.name" class="input300" :placeholder="`请输入`" />
        </el-form-item>
        <!-- 院区 -->
        <el-form-item :label="`院区`" prop="site_id">
          <el-select v-model="formCenter.site_id" clearable filterable class="input300" :placeholder="`请选择`">
            <el-option
              v-for="item in siteOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 负责人 -->
        <el-form-item :label="`负责人`" prop="user">
          <el-input v-model="formCenter.user" class="input300" :placeholder="`请输入`" />
        </el-form-item>
        <!-- 工号 -->
        <el-form-item :label="`工号`" prop="empcode">
          <el-input v-model="formCenter.empcode" class="input300" :placeholder="`请输入`" />
        </el-form-item>
        <!-- 账号 -->
        <el-form-item :label="`账号`" prop="username">
          <el-input v-model="formCenter.username" autoComplete="off" class="input300" :placeholder="`请输入`" />
        </el-form-item>
        <!-- 密码 -->
        <el-form-item :label="`密码`" prop="password">
          <el-input type="password" autoComplete="new-password" v-model="formCenter.password" class="input300" :placeholder="`请输入`" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- 保 存 -->
        <el-button size="mini" :loading="buttonLoading" type="primary" @click="submitFormCenter">保存</el-button>
        <!-- 关闭 -->
        <el-button size="mini" @click="openCenter = false;">取消</el-button>
      </div>
    </el-dialog>

    <!-- 院区对话框 -->
    <el-dialog :title="title" :visible.sync="openSite" width="1000px" append-to-body>
      <el-form ref="formsite" :model="formsite" :rules="rulessite">
        <!-- 院区 -->
        <el-form-item :label="`院区`" prop="name">
          <el-input v-model="formsite.name" class="input300" :placeholder="`请输入`" />
          <!-- 新建 -->
          <el-button type="primary" class="ml10" icon="el-icon-plus" size="mini" @click="submitCreate">新建</el-button>
        </el-form-item>
      </el-form>
      <el-table border stripe v-loading="loading" :data="siteList">
          <el-table-column type="index" label="#" align="center" width="50"/>
          <!-- 名称 -->
          <el-table-column :label="`名称`" align="center">
            <template slot-scope="scope">
              <span v-if="!scope.row.editshow">{{scope.row.name}}</span>
              <el-input v-if="scope.row.editshow" v-model="changname" :placeholder="`请输入`" />
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column :label="`操作`"> 
            <template slot-scope="scope">
              <!-- 编辑 -->
              <el-tooltip v-if="!scope.row.editshow" class="item" effect="dark" :content="`编辑`" placement="top-start">
                  <el-button type="text" class="fontsize20 p0" @click="editbutshow(scope.$index)" icon="el-icon-edit-outline"></el-button>
              </el-tooltip>
              <!-- 删除 -->
              <el-tooltip v-if="!scope.row.editshow" effect="dark" :content="`删除`" placement="top-start">
                <el-button class="p0 fontsize20" type="text" @click="deleteSite(scope.row.id)"><i class="el-icon-delete"></i></el-button>
              </el-tooltip>
              <!-- 保存 -->
              <el-tooltip v-if="scope.row.editshow" class="item" effect="dark" :content="`保存`" placement="top-start">	
                <el-button type="text" class="fontsize20 p0" @click="editSite(scope.row.id)" icon="el-icon-circle-check"></el-button>
              </el-tooltip>
              <!-- 取消 -->
                <el-tooltip v-if="scope.row.editshow" class="item" effect="dark" :content="`取消`" placement="top-start">
                  <el-button type="text" class="fontsize20 p0" @click="cancelsite(scope.$index)" icon="el-icon-circle-close"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <!-- 取 消 -->
        <el-button size="mini" @click="openSite = false;">取消</el-button>
      </div>
    </el-dialog>
    <!-- 科室管理 -->
    <ImportFile :link="'/template/basic/department/'+`科室管理`+'.xlsx'" ref="importFile" @complete="getImport" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Pagination from '@/components/common/Pagination.vue'
import TableHeaderEditor from '@/components/common/TableHeaderEditor.vue'
import ImportFile from '@/components/common/ImportFile.vue'
import { deptList,deptEdit, deptDelete, centerList, deptGroupList,deptGroupEdit, deptGroupDelete, getSite, departmentOptions, siteCreate, siteEdit, siteDelete, deptImport, deptPull, getDepartFromOther } from '@/api.js' 
import { pageSize } from '@/utils/Config.js'
export default {
    name:'departmentIndex',
    components: {
      Pagination,
      TableHeaderEditor,
      ImportFile
    },
    data() {
        return {
            //tab切换
            activeName:"first",
            // 查询参数
            queryParams: {
              pageIndex: 1,
              pageSize,
              _total: 0,
              name: '',
              site_id:'',
              center_id:'',
              type:''
            },
            queryGruopParams: {
              pageIndex: 1,
              pageSize,
              _total: 0,
              name:'',
            },
            tableHeaders: [],
            tableHeadersTwo: [],
            //科室列表
            departmentList:[],
            siteOptions:[],
            //科室组列表
            departmentGroupList: [],
            //处理中心列表
            deptCenter:[],
            loading:true,
            //类别
            typeOptions:[],
            //科室组下拉
            deptGroupOption:[],
            // his科室下拉
            his_departments: [],
            // 弹出层标题
            title: "",
            // 按钮loading 
            buttonLoading: false,
            // 科室弹出层
            open: false,
            // 科室组弹出层
            openGroup:false,
            // 处理中心弹出层
            openCenter:false,
            departmentOption:false,
            //院区弹出层
            openSite:false,
            //院区列表
            siteList:[],
            changname:'',
            // 表单参数
            form: {
              order: 0,
            },
            formGroup: {},
            formCenter:{},
            formsite:{},
            // 科室表单校验
            rules: {
              name: [
              // 科室不能为空
                { required: true, message: `科室不能为空`, trigger: "blur" }
              ],
              type: [
              // 类型不能为空
                { required: true, message: `类型不能为空`, trigger: "change" }
              ],
              
            },
            rulesGroup:{
              name: [
              // 科室组不能为空
                { required: true, message: `科室组不能为空`, trigger: "blur" }
              ],
            },
            //处理中心表单校验
            rulesCenter: {
              name: [
              // 处理中心不能为空
                { required: true, message: `处理中心不能为空`, trigger: "blur" }
              ],
              site_id: [
              // 院区不能为空
                { required: true, message: `院区不能为空`, trigger: "blur" }
              ],
              user: [
              // 负责人不能为空
                { required: true, message: `负责人不能为空`, trigger: "blur" }
              ],
              username: [
              // 账号不能为空
                { required: true, message: `账号不能为空`, trigger: "blur" }
              ],
              empcode: [
              // 工号不能为空
                { required: true, message: `工号不能为空`, trigger: "blur" }
              ],
              password: [
              // 密码不能为空
                { required: true, message: `密码不能为空`, trigger: "blur" }
              ],
            },
            rulessite:{
              name: [
                // { required: true, message: "院区名称不能为空", trigger: "blur" }
              ],
            }
        }
    },
    computed: {
      ...mapGetters(['user', 'exec'])
    },
    created() {
      this.getdepartmentList();
      this.getDepartmentGroupList();
      this.getdept();
      this.getsiteList();
      // this.searchCenter();
      this.pageId = Number(this.$route.params.id)
      if (this.pageId) {
          this.getDetail(this.pageId)
      }
    },
    methods: {
      // 表单重置
      reset() {
        this.form = {
          id: undefined,
          type:undefined,
          user:undefined,
          phone:undefined,
          deadline:undefined,
          description:undefined,
        };
        this.formGroup = {
          name:undefined,
        };
        this.formCenter = {
          name:undefined,
          user:undefined,
          username:undefined,
          empcode:undefined,
          password:undefined,
        };
        this.formsite = {
          name:undefined,
        }
      },
      /** 查询科室列表 */
      getSearch(){
        this.queryParams.pageIndex = 1;
        this.getdepartmentList();
      },
      importList() {
        // 开始导入
        this.$refs.importFile.show()
      },
      getImport(file) {
        // 接收导入文件信息
        const info = {
          file_id: file.fileId
        }
        this.$request('post', deptImport, info)
        .then((res) => {
          if (res) {
            // 导入成功
            this.$message.success(`导入成功`)
            this.getdepartmentList()
          }
        })
      },
      handleClick() {
        switch (this.activeName) {
          case 'first':
            this.getdepartmentList()
            break;
        
          case 'second':
            this.getDepartmentGroupList()
            break;
        }
      },
      getdepartmentList() {
        // 获取列表数据
        const url = deptList
        const {
          pageIndex,
          pageSize,
          name,
          site_id,
          center_id,
          orderBy,
          order,
          type
        } = this.queryParams
        const queryParams = {
          page: pageIndex,
          per_page: pageSize,
          name,
          site_id,
          center_id,
          order_column: orderBy,
          order,
          type
        }
        this.$request('get', url, queryParams)
        .then((res) => {
          if (res) {
            const prev = [
              {
                width: 60,
                label: '#',
                prop: '',
                type: 'index',
                checked: true
              }
            ]
            const last = [
              {
                width: 'auto',
                // 操作
                label: `操作`,
                prop: '',
                checked: true,
                handle: true
              }
            ]

            this.tableHeaders = this.tableHeaders.length > 0 ? this.tableHeaders : this.$utils.generateColumns(res.columns, prev, last)
            // console.log(this.tableHeaders);
            this.departmentList = res.data;
            this.typeOptions = res.type;
            this.deptGroupOption = res.department_group;
            this.queryParams._total = res.total;
          }
        })
        this.loading = false;
      },
      getdept(){
        const url = departmentOptions
        this.$request('get', url).then(res=>{
          if (res) {
            this.departmentOption = res;
          }
        })
      },
      changeCenterdept(){
        const url = departmentOptions
        this.$request('get', url, {center_id:this.form.center_id}).then(res=>{
          if (res) {
            this.departmentOption = res;
          }
        })
      },
      getDep(query, cb) {
        // 查询科室
        const params = {
          name: query || ''
        }
        this.$request('get', departmentOptions, params)
        .then((res) => {
          if (res) {
            this.depOptions = res

            if (cb) {
              cb(res)
            }
          }
        })
      },
      sortChange(item) {
        // 排序方法
        const { column, order } = item
        const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
        const orderBy = order ? column.sortBy : undefined

        this.queryParams.order = orderString
        this.queryParams.orderBy = orderBy
        this.getdepartmentList()
      },
      // 新建科室
      createDepartment(){
        this.reset();
        this.open = true;
        // 新建科室
        this.title = `新建科室`;
      },
      //编辑科室
      editDepartment(row) {
        this.form=row;
        if(this.form.parent_id == 0){
          this.form.parent_id =''
        }
        if(this.form.site_id == 0){
          this.form.site_id =''
        }
        if (this.form.out_plan_type == 0) {
          this.form.out_plan_type = ''
        }
        // this.form.need_use_record = this.form.need_use_record === 1
        // this.form.is_limit_apply = this.form.is_limit_apply === 1
        // this.form.hide_outdated = this.form.hide_outdated === 1

        if(this.form.need_use_record === 1){
          this.form.need_use_record = true
        }
        if(this.form.is_limit_apply === 0){
          this.form.is_limit_apply = true
        }
        if(this.form.hide_outdated === 1){
          this.form.hide_outdated = true
        }
        
        this.open = true;
        // 编辑科室
        this.title = `编辑科室`;
      },
      //科室取消
      closedept(){
        this.open = false;
        this.getdepartmentList();
      },
      //科室组取消
      closeGroup(){
        this.openGroup = false;
        this.getDepartmentGroupList();
      },
      //查询院区
      getsiteList(){
        const url = getSite
        this.$request('get', url).then(res=>{
            this.siteOptions=res;
            this.siteList = res;
        })
      },
      //删除科室
      deleteDepartment(id) {
        // 确认删除吗？
        this.$confirm(`确认删除吗?`,{
          type: 'warning',
          // 确定
          confirmButtonText: `确定`,
          // 取消
          cancelButtonText: `取消`,
        })
        .then(() => {
          const url = deptDelete.replace('{id}', id)
          this.$request('post', url, {})
          .then((res) => {
            if (res == 0) {
              // 删除成功
              this.$message.success(`删除成功`)
              this.getdepartmentList()
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
      },
      // 科室保存
      submitForm: function() {
        this.$refs["form"].validate(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.form.need_use_record = this.form.need_use_record ? 1 : 0
            this.form.is_limit_apply = this.form.is_limit_apply ? 0 : 1
            this.form.hide_outdated = this.form.hide_outdated ? 1 : 0
            if (this.form.id != null) {
                const url = deptEdit.replace('{id}', this.form.id)
                this.$request('post', url, this.form).then(() => {
                  // 修改成功
                  this.$message.success(`修改成功`);
                  this.open = false;
                  this.getdepartmentList();
              }).finally(() => {
                this.buttonLoading = false;
              });
            }else {
              const urltwo = deptList
              this.$request('post', urltwo, this.form).then(res => {
                if(res){
                  // 新增成功
                  this.$message.success(`新增成功`);
                  this.open = false;
                  this.getdepartmentList();
                }
              }).finally(() => {
                this.buttonLoading = false;
              });
            }
          }
        });
      },
      
      getSearchGroup(){
        this.queryGruopParams.pageIndex = 1;
        this.getDepartmentGroupList();
      },
      //科室组列表
      getDepartmentGroupList(){
        const url = deptGroupList
        const {
          pageIndex,
          pageSize,
          name,
          orderBy,
          order
        } = this.queryGruopParams
        const queryGruopParams = {
          page: pageIndex,
          per_page: pageSize,
          name,
          order_column: orderBy,
          order,
        }
        this.$request('get', url, queryGruopParams)
        .then((res) => {
          if (res) {
            const prev = [
              {
                width: 60,
                label: '#',
                prop: '',
                type: 'index',
                checked: true
              }
            ]
            const last = [
              {
                width: 'auto',
                // 操作
                label: `操作`,
                prop: '',
                checked: true,
                handle: true
              }
            ]

            this.tableHeadersTwo = this.tableHeadersTwo.length > 0 ? this.tableHeadersTwo : this.$utils.generateColumns(res.columns, prev, last)
            this.departmentGroupList = res.data
            this.queryGruopParams._total = res.total
          }
        })
        this.loading = false;
      },
      sortGroupChange(item) {
        // 排序方法
        const { column, order } = item
        const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
        const orderBy = order ? column.sortBy : undefined

        this.queryParams.order = orderString
        this.queryParams.orderBy = orderBy
        this.getDepartmentGroupList()
      },
      //新建科室组
      createGruop(){
        this.reset();
        this.openGroup = true;
        // 新建科室组
        this.title = `新建科室组`;
      },
      // 保存科室组
      departmentGropCreate(){
        this.$refs["formGroup"].validate(valid => {
          if (valid) {
            this.buttonLoading = true;
            if (this.formGroup.id != null) {
                const url = deptGroupEdit.replace('{id}', this.formGroup.id)
                this.$request('post', url, this.formGroup).then(res => {
                  if(res){
                    // 修改成功
                    this.$message.success(`修改成功`);
                    this.openGroup = false;
                    this.getDepartmentGroupList();
                  }
              }).finally(() => {
                this.buttonLoading = false;
              });
            }else {
              const urltwo= deptGroupList 
              this.$request('post', urltwo, this.formGroup).then(res => {
                if(res){
                  // 新增成功
                  this.$message.success(`新增成功`);
                  this.openGroup = false;
                  this.getDepartmentGroupList();
                }
              }).finally(() => {
                this.buttonLoading = false;
              });
            }
          }
        });
      },
      // 科室组编辑
      departmentGroupEdit(row){
        this.formGroup = row;
        this.openGroup = true;
        // 编辑科室组
        this.title = `编辑科室组`;
      },
      getHisDeparts(name = '') {
        // 查询his科室组
        const { site_id } = this.form
        const query = {
          name,
          site_id
        }
        this.$request('get', getDepartFromOther, query)
        .then(res => {
          if (res) {
            this.his_departments = res
          }
        })
      },
      clearHisDep() {
        // 清除院区后
        this.$set(this.form, 'his_name', '')
        this.changeHisDepart()
      },
      changeHisDepart() {
        // 选择his科室名称赋值code
        const { his_name } = this.form

        if (!his_name) {
          this.$set(this.form, 'his_code', '')
        }

        const item = this.his_departments.filter(i => i.dept_name === his_name)[0]
        if (item) {
          const { dept_code } = item
          this.$set(this.form, 'his_code', dept_code)
        }
      },
      //删除科室组
      deletedeptGroup(id) {
        // 确认删除吗？
        this.$confirm(`确认删除吗?`,{
          type: 'warning',
          // 确定
          confirmButtonText: `确定`,
          // 取消
          cancelButtonText: `取消`,
        })
        .then(() => {
          const url = deptGroupDelete.replace('{id}', id)
          this.$request('post', url, {})
          .then((res) => {
            if (res == 0) {
              // 删除成功
              this.$message.success(`删除成功`)
              this.getDepartmentGroupList()
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
      },
      //新建处理中心
      createProcesscenter(){
        this.reset();
        this.openCenter = true;
        // 添加处理中心
        this.title = `添加处理中心`;
      },
      //查询处理中心
      searchCenter(){
        const url = centerList
        this.$request('get', url).then(res=>{
            this.deptCenter = res;
        })
      },
      //保存处理中心
      submitFormCenter(){
        const url = centerList
        this.$refs["formCenter"].validate(valid => {
          if (valid) {
            this.$request('post', url, this.formCenter).then(res =>{
              if(res){
                // 新增成功
                this.$message.success(`新增成功`)
                this.openCenter = false;
              }
            }).finally(() => {
              this.buttonLoading = false;
            });
          }
        });
      },
      // 同步数据
      pullData() {
        this.$request('post', deptPull)
        .then((res) => {
          if (res) {
            // 操作成功
            this.$message.success(`操作成功`)
            this.getdepartmentList()
          }
        })
      },
      //新增院区
      createSite(){
        this.openSite = true;
        // 添加院区
        this.title = `添加院区`;
      },
      //编辑院区
      editbutshow(index){
        // sessionStorage.setItem
        this.$set(this.siteList[index],'editshow',true)
        this.changname = this.siteList[index].name
      },
      //取消编辑
      cancelsite(index){
        this.$set(this.siteList[index],'editshow',false)
      },
      //删除院区
      deleteSite(id) {
        // 确认删除吗？
        this.$confirm(`确认删除吗?`,{
          type: 'warning',
          // 确定
          confirmButtonText: `确定`,
          // 取消
          cancelButtonText: `取消`,
        })
        .then(() => {
          const url =  siteDelete.replace('{id}', id)
          this.$request('post', url, {})
          .then((res) => {
            if (res) {
              this.getsiteList()
              // 删除成功
              this.$message.success(`删除成功`)
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
      },
      // 新增院区
      submitCreate(){
        if(this.formsite.name == undefined){
          // 请填写院区名称
          this.$message.warning(`请填写院区名称`);
        }else{
          this.$refs["formsite"].validate(valid => {
            if (valid) {
                const url= siteCreate 
                this.$request('post', url, this.formsite).then(res => {
                  if(res){
                    this.getsiteList();
                    // 新增成功
                    this.$message.success(`新增成功`);
                    this.reset();
                  }
                }).finally(() => {
                  this.buttonLoading = false;
                });
              }
          });
        }
      },
      //编辑院区
      editSite(id){
        this.$refs["formsite"].validate(valid => {
          if (valid) {
            const url= siteEdit.replace('{id}', id) 
            this.formsite.name = this.changname
            this.$request('post', url, this.formsite).then(res => {
              if(res){
                this.getsiteList();
                // 修改成功
                this.$message.success(`修改成功`);
                this.formsite.name = undefined;
              }
            }).finally(() => {
              this.buttonLoading = false;
            });
          }
        });
      }
    }
}
</script>

<style lang="scss" scoped>
.instrument_index{
  .instrument_center{
    background: white;
    padding: 10px;
    border-radius: 10px;
  }
  .imageSize{
    font-size: 22px;
  }
  .header-editor {
    position: relative;
    right: 10px;
    z-index: 5;
    top:5px;
  }
  .qr-code {
    height: 60px;
    width: auto;
  }
} 
</style>